import {
  AdminFooterContainer,
  FooterLeftContent,
  FooterPlacehoder,
} from './styles';

const AdminFooter = () => (
  <AdminFooterContainer>
    <FooterPlacehoder>Footer Placeholder</FooterPlacehoder>
    <FooterLeftContent>
      Disclosure statement lorem ipsum dolor sit amenta nunca sapienta
    </FooterLeftContent>
  </AdminFooterContainer>
);

export default AdminFooter;
